/**
 * @desc 修改(调整，新增钉钉部门id字段)
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: defs.ucenter.OrganizationStaffRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/organizationStaff/update`, {
      method: "PUT",

      data: body,
      ...options,
    }),
  );
}
